enum Locale {
	en = 'en',
	fr = 'fr',
	nl = 'nl'
}

export {Locale};
